import {
  useConsignmentReports,
  type ConsignmentReportType,
  type ConsignmentDownloadParams
} from '@/entities/consignments';

/**
 * @deprecated Use useConsignmentReports from @/entities/consignments instead.
 * This is kept for backward compatibility within the show-disposition feature.
 */
export const useReportDownload = useConsignmentReports;

export type ReportType = ConsignmentReportType;
export type DownloadParams = ConsignmentDownloadParams;
